import RetinarLogo from '../../assets/images/lightblue_logo.png'
import AboutRetinarRotulo from '../../assets/images/about-retinar-rotulo.png'
import { USER_MANUAL_URL } from '../../const/manual'
import { APP_VERSION_LABEL } from '../../const/version'

export const ABOUT_RETINAR_CONTENT = {
  menuLabel: 'Acerca de Retinar',
  title: 'Acerca de Retinar',
  tabs: {
    label: 'Rótulo',
    additionalInformation: 'Información adicional'
  },
  image: {
    src: AboutRetinarRotulo,
    alt: 'Rótulo oficial de Retinar'
  },
  hero: {
    logoSrc: RetinarLogo,
    logoAlt: 'Logo Retinar',
    name: 'Retinar®',
    description: 'Sistema para tamizaje de retinopatía diabética asistido por teleoftalmología e inteligencia artificial'
  },
  sections: [
    {
      title: 'Identificación del producto',
      items: [
        { label: 'Nombre comercial', value: 'Retinar®' },
        { label: 'Tipo de dispositivo', value: 'Software como Dispositivo Médico (SaMD)' },
        { label: 'Versión de software', value: APP_VERSION_LABEL },
        { label: 'Fecha de fabricación / liberación', value: '17 de octubre de 2026' },
        { label: 'Estado', value: 'Versión vigente hasta su reemplazo por una versión posterior validada' },
        { label: 'Identificador de lote o serie', value: `${APP_VERSION_LABEL} (release visible equivalente de lote/serie)` },
        { label: 'Clase de riesgo ANMAT', value: 'Clase II' },
        { label: 'Estado regulatorio ANMAT', value: 'PM [en trámite al momento]' }
      ]
    },
    {
      title: 'Fabricante y responsable técnico',
      items: [
        { label: 'Fabricante legal / titular', value: 'Retinar S.A.S.' },
        { label: 'Domicilio legal', value: 'San Francisco 1678, Tandil, Buenos Aires, Argentina' },
        { label: 'Responsable técnico', value: 'Dr. José Ignacio Orlando, Ingeniero de Sistemas, Matrícula 2733 (CPCIBA)' }
      ]
    },
    {
      title: 'Soporte y documentación',
      items: [
        { label: 'Teléfono', value: '+54 249 4209638', href: 'tel:+542494209638' },
        { label: 'Email', value: 'soporte@retinar.com.ar', href: 'mailto:soporte@retinar.com.ar' },
        { label: 'Sitio web', value: 'www.retinar.com.ar', href: 'https://www.retinar.com.ar' },
        { label: 'Manual de usuario', value: 'Abrir manual de usuario', href: USER_MANUAL_URL },
        {
          label: 'Copia impresa',
          value: 'Solicitar copia impresa por email',
          href: 'mailto:soporte@retinar.com.ar?subject=Solicitud%20de%20copia%20impresa%20de%20Retinar'
        }
      ]
    }
  ],
  warnings: {
    title: 'Advertencias y precauciones',
    items: [
      'Retinar es una herramienta de apoyo al tamizaje y no reemplaza la evaluación de un profesional de la salud.',
      'Para las instrucciones completas de operación y uso, consultar el manual de usuario vigente.',
      'Los campos regulatorios no aplicables a un SaMD se omiten para evitar interpretaciones ambiguas o equivalencias artificiales.'
    ]
  }
}
